import { Note } from '@card-software/library';
import { Yarn } from '../item/yarn/yarn';
import { Business } from '../finance/business';

export interface KnittingOrder {
  id: string;
  workOrderReference: string;
  workOrderNumber: string;
  knittingOrderNumber: string;
  issuedQuantity?: number;
  fabricQuantityDetails: FabricQuantityDetail[];
  greigeQuantityDetails?: GreigeQuantityDetail[];
  createdDate?: Date;
  createdBy?: null | string;
  modifiedBy?: string;
  modifiedDate?: Date;
  notes?: Note[];
  locationCode: string;
}

export interface FabricQuantityDetail {
  fabricCode: string;
  quantity: number;
  variantCode: string;
  unitOfMeasure: number;
  yarnAndProviderInfos: YarnAndProviderInfo[];
}
export interface YarnAndProviderInfo {
  yarnCode: string;
  yarn?: Yarn;
  providerReference?: string;
  provider?: Business;
  providerLotNumber?: string;
}

export interface GreigeQuantityDetail {
  greigeReference: string;
  quantity: number;
  unitOfMeasure: number;
}

export interface KnittingOrderSearchCommand {
  knittingOrderNumber?: string;
  statuses?: number[];
}

export enum KnittingOrderStatus {
  Submitted = 1,
  Approved = 2,
  InProgress = 3,
  Closed = 4,
  Voided = 5,
}
